import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Layout, Segment, message, Select } from 'tea-component';
import type { PagingQuery } from 'tea-component';
import AboutTheData from './components/AboutTheData';
import TipContext from '@/pages/home/components/TipContext';
import RevenueTrends from './components/RevenueTrends';
import Retention from './components/Retention';
import RevenueSelector from './components/RevenueSelector';
import SystemRatios from './components/SystemRatios';
import TableContent from './components/TableContent';
import FollowGame from '@/pages/intelligence/pages/PCConsoleBenchmark/components/FollowGame';
// import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { getCountryFlag } from '@/pages/home/_config/countries';
import AddEntities from './components/AddEntities';
import {
  getMobileBenchmarkGameList,
  getMobileBenchmarkFigured,
  getMobileBenchmarkRankList,
  getMobileBenchmarkLevelList,
  getMobileBenchmarkRegionFilter,
  addMobileBenchmarkCustomizeGame,
  getBenchmarkCustomizeTopsGameList,
} from '../../services/mobileGameBenchmark';
import { getCollectionGroupByEntityTypes } from '../../services/pcConsoleBenchmark'
import {
  GameSegmentOptions,
  StatusSegmentOptions,
  StatsFilterDefaultValue,
  StatsFilterGroupConfig,
} from './_config/constant';
import { TimePeriodType, GameSegmentType, StatsSegmentType } from './types';

import { cloneDeep, debounce, reduce } from 'lodash-es';
import { useIntl, getLocale } from 'umi';

import './index.scss';

import {
  buriedPointPage,
  buriedBtnPoint,
} from '@/pages/home/utils/buriedPoint';
import {
  dbiBtnLogMes,
  dbiPageLogMes,
} from '@/pages/intelligence/utils/buriedPointCfg';
import RegionSelect from './components/RegionSelect';
import GameLevelSelect from './components/GameLevelSelect';
import classnames from 'classnames';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Body, Content } = Layout;

const MobileGameBenchMark = () => {
  // Figure 部分
  /** tab activeId */
  const [activeId, setActiveId] = useState('Figure');
  /** 穿梭框visible */
  const [visible, setVisible] = useState(false);
  /** figure loading */
  const [figureLoading, setFigureLoading] = useState(false);
  /** setting 打开 */
  const [isTextOpen, setIsTextOpen] = useState(false);
  /** 游戏分类 activeSegment */
  const [activeSegment, setActiveSegment] = useState('gacha');
  /** 控制穿梭空 shortcut按钮异步请求问题 */
  const [settingLoading, SetSettingLoading] = useState(false);
  /*** 自定义游戏值 */
  const [customLoading, setCustomLoading] = useState(false);
  /*** 自定义游戏列表 */
  const [customGameList, setCustomGameList] = useState<any[]>([]);
  /** 全部游戏列表，用于游戏穿梭框筛选用 */
  const [allGameList, setAllGameList] = useState<any[]>([]);
  const [source, setSource] = useState('appannie');

  const [regionConfig, setRegionConfig] = useState({
    figure: [],
    kpi_data: [],
    player_activity: [],
  });

  /** 区域 region  */
  const [region, setRegion] = useState(['global_wo_china']);
  const [groupList, setGroupList] =  useState<any[]>([]);

  /** 游戏层级 */
  const [levelValue, setLevelValue] = useState({
    S: [],
    A: [],
    B: [],
    C: [],
  });
  /** 游戏层级列表 */
  const [levelOptions, setLevelOptions] = useState([]);
  const [timeLine, setTimeLine] = useState('original');
  const [timePeriod, setTimePeriod] = useState<TimePeriodType>('1y~5y');
  /** figure部分展示数据 */
  const [figureData, setFigureData] = useState({
    trendsData: {
      revenue: [],
      downloads: [],
      dau: [],
    },
    arpuRetention: [],
    ageBreakdown: [],
    genderBreakdown: [],
    ratioRegion: {
      lty: [],
      register: [],
      cpi: [],
    },
    retentionCurve: [],
    mobileDevice: {},
    gameTotal: 0,
    summaryData: [], // Summary数据
    revenueRegional: {
      revenue: [],
      downloads: [],
      dau: [],
    }, // Regional Distribution of Revenue饼图数据
  });

  // stats 部分
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  /** Table加载loading*/
  const [tableLoading, setTableLoading] = useState(false);
  /** totalNum */
  const [totalNum, setTotalNum] = useState(0);
  /** 筛选器值 */
  const [statsFilterValue, setFilterValue] = useState(
    StatsFilterDefaultValue.kpi_data,
  );
  const [dataSource, setDataSource] = useState<any[]>([]);
  /** stats active segment */
  const [
    statsActiveSegment,
    setStatsActiveSegment,
  ] = useState<StatsSegmentType>('kpi_data');

  const [apiParams, setApiParams] = useState<any>({});

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [levelGameList, setGameLevelList] = useState([])

  const benchmarkRef = useRef<HTMLDivElement>(null);
  const statsRef = useRef<HTMLDivElement>(null);

  const tabSegment = [
    { text: formatMessage({ id: 'dbi_benchmark_figure' }), value: 'Figure' },
    { text: formatMessage({ id: 'dbi_benchmark_stats' }), value: 'Stats' },
  ];

  const sourceOptions = [
    { text: 'data.ai', value: 'appannie' },
    { text: 'DataBrain', value: 'databrain' },
  ];

  /** 获取国家 */
  // const { regionOptions } = useMarketFilterApi({});

  const gameSegmentList = useMemo(() => {
    return GameSegmentOptions?.map((item) => ({
      ...item,
      text: item?.info ? (
        <span className="dbi-benchmark-segment-text">
          <span className="dbi-benchmark-segment-title">
            {formatMessage({ id: item?.text || '' })}
          </span>
          <TipContext
            className="tip-icon"
            AWidth={555}
            placement="top"
            tipText={formatMessage({ id: 'dbi_benchmark_tops_info' })}
          />
        </span>
      ) : (
        formatMessage({ id: item?.text || '' })
      ),
    }));
  }, [locale]);

  const statusSegmentList = useMemo(() => {
    return StatusSegmentOptions?.map((item) => ({
      ...item,
      text: formatMessage({ id: item?.text || '' }),
    }));
  }, [StatusSegmentOptions, locale]);

  /** benchmark页面滚动事件 */
  const handleBenchmarkScroll = debounce((e) => {
    if (statsRef.current) {
      const height =
        document.body.clientHeight || document.documentElement.clientHeight;
      // 目标元素距离可视区域的宽度
      const top = statsRef.current?.getBoundingClientRect()?.top;
      // 如果stats出现在屏幕中间一下属于figure部分
      const target = (height - 50 - 40) / 2;
      if (top < target) {
        setActiveId('Stats');
      } else {
        setActiveId('Figure');
      }
    }
  }, 200);

  const handleTabSegmentChange = (value: string) => {
    setActiveId(value);
    if (value === 'Figure') {
      getFigureBenchmarkData({});
      const pageMsg = dbiPageLogMes?.mobileGameBenchmarkFigure;
      if (pageMsg) {
        buriedPointPage(pageMsg);
      }
    }

    if (value === 'Stats') {
      getTableList({
        page: 1,
        ...statsFilterValue,
      });
      if (['kpi_data', 'player_activity'].includes(statsActiveSegment)) {
        getRegionList(statsActiveSegment);
      }
      const pageMsg = dbiPageLogMes?.mobileGameBenchmarkStatus;
      if (pageMsg) {
        buriedPointPage(pageMsg);
      }
    }
  };

  /** 游戏分类segment change事件 */
  const handleSegmentChange = async (value: GameSegmentType) => {
    if (activeSegment === value) return;
    setActiveSegment(value);
    if (value === 'customize_mobile' && !customGameList?.length) {
      // 当Customized为空态时，隐藏Customize a game set，且点击Customized后弹出弹窗选择游戏
      setVisible(true);
      return;
    }
    getGameLevelList({
      genre_type: value,
    });
    if (activeId === 'Figure') {
      getFigureBenchmarkData({ genre_type: value, select_ids: [] });
    }
    if (activeId === 'Stats') {
      getTableList({
        page: 1,
        genre_type: value,
        select_ids: [],
      });
    }
  };

  const handleTransferCancel = () => {
    // if (!isTextOpen) {
    //   setActiveSegment1(lastSegment);
    // }
    setIsTextOpen(false);
    setVisible(false);
    const btnMsg = dbiBtnLogMes?.pcConsoleBenchmarkCustomizeConfirm;
    btnMsg && buriedBtnPoint(btnMsg);
  };

  const handleTransferConfirm = async (value: string[]) => {
    // 若已经在Customized选过游戏了，再次打开Customize a game set弹窗
    // 并删除全部游戏，则默认回到SOC页并提示

    await addMobileBenchmarkCustomizeGame({
      game_ids: value || [],
      genre_type: 'customize_mobile',
    });
    const btnMsg = dbiBtnLogMes?.mobileGameBenchmarkCustomizeConfirm;
    btnMsg && buriedBtnPoint(btnMsg);
    getBenchmarkGameList();
    getGameLevelList({
      genre_type: 'customize_mobile',
    });

    if (!value.length) {
      message.success({
        content: 'Custom games have been cleared.',
      });
      setActiveSegment('gacha');
      getTableList({
        page: 1,
        genre_type: 'gacha',
      });
    } else {
      setActiveSegment('customize_mobile');
      if (activeId === 'Figure') {
        getFigureBenchmarkData({
          genre_type: 'customize_mobile',
          select_ids: value,
        });
      }

      if (activeId === 'Stats') {
        getTableList({ genre_type: 'customize_mobile', select_ids: value });
      }
    }

    setVisible(false);
    setIsTextOpen(false);
  };

  const handleSetting = async () => {
    setIsTextOpen(true);
    setVisible(!visible);
    const btnMsg = dbiBtnLogMes?.mobileGameBenchmarkSetting;
    if (btnMsg) {
      buriedBtnPoint(btnMsg);
    }
  };

  const handleStatsSegmentChange = (value: StatsSegmentType) => {
    if (['kpi_data', 'player_activity'].includes(value)) {
      getRegionList(value);
    }
    setStatsActiveSegment(value);
    setFilterValue(StatsFilterDefaultValue[value]);
    getTableList({
      page: 1,
      source_tab: value,
      ...StatsFilterDefaultValue['kpi_data'],
      ...StatsFilterDefaultValue[value],
    });
  };

  useEffect(() => {
    getRegionList('figure');
    getBenchmarkGameList();
    getGameLevelList();
    getFigureBenchmarkData({});
    getCollectionGroupList();
    // 页面初始打点
    const pageMsg = dbiPageLogMes?.mobileGameBenchmarkFigure;
    if (pageMsg) {
      buriedPointPage(pageMsg);
    }
  }, []);


  const getCollectionGroupList = async()=> {
    const res:any = await getCollectionGroupByEntityTypes(['mobile']);
    const list = res?.group_lists || []
    
    if(Array.isArray(list)){
      const groupList = list.reduce((result, item)=> {
       const group = item?.group_lists || [];
       return result.concat(Array.isArray(group) ? group: []);
      }, [])
      setGroupList(groupList)
    }else{
      setGroupList([]);
    }
  }
   

  const getRegionList = async (
    type: 'figure' | 'kpi_data' | 'player_activity',
  ) => {
    if (!regionConfig[type]?.length) {
      const res = await getMobileBenchmarkRegionFilter({
        filter_type: type,
      });

      if (Array.isArray(res)) {
        const config = cloneDeep(regionConfig);
        config[type] = res;
        setRegionConfig(config);
      }
    }
  };

  /*** 获取游戏列表 */
  const getBenchmarkGameList = async () => {
    setCustomLoading(true);
    const res = await getMobileBenchmarkGameList({
      entity_type: 'mobile',
      genre_types: [
        'gacha',
        'casual',
        'mmo',
        'slg',
        'sports',
        'top',
        'shooter',
        'customize_mobile',
      ],
    });

    const list = res || [];
    const customGame = list.find(
      (item) => item?.genre_type === 'customize_mobile',
    );
    if (customGame) {
      const gameList = customGame?.list?.map((item) => ({
        gameId: item.id,
        gametitle: item.entity_name,
        text: item.company,
        img: item.cover,
        countryIcon: getCountryFlag(item.company_country),
      }));
      setCustomGameList(gameList);
    }
    setAllGameList(list);
    setCustomLoading(false);
  };

  /** 获取figure部分数据 */
  const getFigureBenchmarkData = async (params: { [key: string]: any }) => {
    setFigureLoading(true);
    const res = await getMobileBenchmarkFigured({
      genre_type: activeSegment,
      time_basis: timeLine,
      time_period: timePeriod,
      regions: region,
      // unified_ids: apiParams?.unified_ids || [],
      select_ids: apiParams?.select_ids || [],
      sources: [apiParams?.source || source],
      ...params,
    });

    const apiParamsConfig = {
      ...apiParams,
      select_ids: params?.select_ids || apiParams?.select_ids || [],
    };

    setApiParams(apiParamsConfig);

    const {
      trends_data,
      mobile_players_by_country,
      summary_data,
      arpu_retention,
      retention_curve,
      age_breakdown,
      gender_breakdown,
      mobile_device,
      ratios_by_region,
      game_total,
    } = res || {};

    setFigureData({
      trendsData: trends_data || {},
      summaryData: summary_data || [],
      revenueRegional: mobile_players_by_country || {},
      arpuRetention: arpu_retention || [],
      retentionCurve: retention_curve || [],
      ageBreakdown: age_breakdown || [],
      genderBreakdown: gender_breakdown || [],
      ratioRegion: ratios_by_region || {},
      mobileDevice: mobile_device || {},
      gameTotal: game_total || 0,
    });

    setFigureLoading(false);
  };
  /** 获取游戏级别列表 */
  const getGameLevelList = async (params?: any) => {
    setLevelOptions([]);
    const res = await getMobileBenchmarkLevelList({
      entity_type: 'mobile',
      genre_type: activeSegment,
      ...params,
    });

    const list = res?.list || [];
    const options = list.reduce((result, item) => {
      const targetLevel = result?.find((config) => config.value === item.level);
      if (targetLevel) {
        targetLevel?.list?.push({
          value: item?.id,
          text: item?.entity_name,
          img: item?.cover,
        });
      } else {
        result.push({
          value: item.level,
          text: item.level,
          list: [
            {
              value: item?.id,
              text: item?.entity_name,
              img: item?.cover,
            },
          ],
        });
      }

      return result;
    }, []);
    let defaultValue = {
      S: [],
      A: [],
      B: [],
      C: [],
    };
    options?.forEach((item) => {
      defaultValue[item?.value] = item?.list?.map((config) => config?.value);
    });
    setGameLevelList(list);
    setLevelValue(defaultValue);
    setLevelOptions(options);
  };

  /** 获取Table 展示数据 */
  const getTableList = async (params?: { [key: string]: any }) => {
    setTableLoading(true);
    const apiParamsSource = {
      ...apiParams,
      page: pageIndex,
      page_size: pageSize,
      genre_type: activeSegment,
      source_tab: statsActiveSegment,
      sources: [apiParams?.source || source],
      order_source: apiParams?.order_source || statsActiveSegment,
      order_metric: apiParams?.order_metric || 'revenue_total',
      order_region: apiParams?.order_region || ['global_wo_china'],
      order: 'desc',
      search_by_name: '',
      ...params,
    };
    try {
      const res = await getMobileBenchmarkRankList(apiParamsSource);
      const { total, rank_au_list } = res?.data || {};
      const orderMetricReq = res?.req?.order_metric || '';
      const reqOrder = res?.req?.order || '';
      const tableList = rank_au_list
        ? rank_au_list?.map((item) => {
            const newMetricMap = {} as any;
            item?.metric_list?.forEach((meticItem) => {
              newMetricMap[meticItem.metric] = meticItem;
            });
            return {
              ...item,
              metric_map: newMetricMap,
            };
          })
        : [];
      setApiParams(apiParamsSource);
      setDataSource(tableList || []);
      setTotalNum(total || 0);
      setTableLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  /** 区域筛选器变化 */
  const handleRegionChange = (value: string[]) => {
    setRegion(value);
    getFigureBenchmarkData({
      regions: value,
    });
  };

  /** 游戏级别选器变化 */
  const handleGameLevelChange = (value) => {
    setLevelValue(value);
    const gameIdList = reduce(
      value,
      (result, value: string[]) => {
        result.push(...value);
        return result;
      },
      [] as any,
    );
    if (activeId === 'Figure') {
      getFigureBenchmarkData({ select_ids: gameIdList });
    } else {
      getTableList({ select_ids: gameIdList });
    }
  };

  /** 时间线类型筛选器 */
  const handleTimeBasicChange = (value: string) => {
    setTimeLine(value);
    getFigureBenchmarkData({ time_basis: value });
  };

  /** 时间线粒度筛选器 */
  const handlePeriodChange = (value: TimePeriodType) => {
    setTimePeriod(value);
    getFigureBenchmarkData({ time_period: value });
  };

  const handlePagingChange = (pageInfo: PagingQuery) => {
    setPageIndex(pageInfo.pageIndex || 1);
    setPageSize(pageInfo.pageSize || 20);
    getTableList({ page: pageInfo.pageIndex, page_size: pageInfo.pageSize });
  };

  /** stats筛选器确认*/
  const handleFilterConfirm = (value) => {
    setFilterValue(value);
    getTableList({ page: 1, ...value });
    const btnMsg = dbiBtnLogMes?.mobileGameBenchmarkStatsConfirm;
    btnMsg && buriedBtnPoint(btnMsg);
  };

  /** stats筛选器重置 */
  const handleFilterRest = () => {
    setFilterValue(StatsFilterDefaultValue[statsActiveSegment]);
    getTableList({
      page: 1,
      ...StatsFilterDefaultValue[statsActiveSegment],
    });
    const btnMsg = dbiBtnLogMes?.mobileGameBenchmarkStatsReset;
    btnMsg && buriedBtnPoint(btnMsg);
  };

  const handleSourceChange = (value: string) => {
    setSource(value);

    if (activeId === 'Figure') {
      getFigureBenchmarkData({ sources: [value] });
    }

    if (activeId === 'Stats') {
      getTableList({ sources: [value] });
    }
  };

  const sourceLabel = useMemo(() => {
    const targetSource = sourceOptions?.find((item) => item.value === source);
    return targetSource?.text || '';
  }, [source]);

  const followGameList = useMemo(()=> {
  
    const gameIdList = reduce(
      levelValue,
      (result, value: string[]) => {
        result.push(...value);
        return result;
      },
      [] as any,
    );
   // const genreGame = allGameList?.find(item=> item?.genre_type === activeSegment);
    // if(!genreGame) return []
    const list = levelGameList?.filter((item:any) => gameIdList?.includes(item?.id));
    // console.log(list)
    return list || [];

  }, [allGameList, activeSegment, levelValue])

  return (
    <Content
      className="dbi-benchmark"
      ref={benchmarkRef}
      // @ts-ignore
      onScroll={handleBenchmarkScroll}
    >
      <div className="dbi-benchmark-infotips">
        <AboutTheData />
      </div>
      <Content.Header
        className="dbi-header contentHead-normal"
        title={formatMessage({ id: 'dbi_benchmark_mobile_game_benchmark' })}
      >
        <div className="dbi-benchmark-header-des">
          {formatMessage({ id: 'dbi_benchmark_introduce_mobile' })}
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        <div className="dbi-mobile-benchmark-tab-container">
          <Segment
            className={
              classnames(['dbi-mobile-benchmark-game-type segment-light', {
                'is-disabled': customLoading || tableLoading || figureLoading
              }])
            } 
            options={gameSegmentList}
            value={activeSegment}
            disabled={customLoading || tableLoading || figureLoading}
            onChange={(value) => handleSegmentChange(value as GameSegmentType)}
          />
          <span
            className="dbi-mobile-benchmark-customize"
            style={
              activeSegment === 'customize_mobile' && customGameList?.length > 0
                ? { display: 'block' }
                : { display: 'none' }
            }
            onClick={handleSetting}
          >
            {formatMessage({ id: 'dbi_benchmark_setting' })}
          </span>
          <Segment
            options={tabSegment}
            value={activeId}
            className={
              classnames(['dbi-benchmark-segment segment-light', {
                //'is-disabled': figureLoading || tableLoading || customLoading
              }])
            } 
            // disabled={figureLoading || tableLoading || customLoading}
            onChange={handleTabSegmentChange}
          />  
        </div>
        <div className="dbi-benchmark-gametype dbi-benchmark-mobile-game">
          <div className="dbi-benchmark-gametype-l">
            <div className="dbi-benchmark-segment-setting">
              <Select
                appearance="button"
                matchButtonWidth
                style={{ marginRight: 10 }}
                value={timePeriod}
                className="dbi-benchmark-source-select"
                button={
                  <>
                    <span className="benchmark-source-select">
                      {formatMessage({ id: 'dbi_source' })}
                    </span>
                    <span>{sourceLabel || ''}</span>
                  </>
                }
                onChange={handleSourceChange}
                options={sourceOptions}
              />
              <GameLevelSelect
                value={levelValue}
                options={levelOptions}
                onChange={handleGameLevelChange}
              />
              <AddEntities
                visible={visible}
                entities={{}}
                entityKey="gameId"
                entityType={'mobile'}
                followedGameList={customGameList}
                allGameList={allGameList}
                customLoading={customLoading}
                onClose={() => handleTransferCancel()}
                onConfirm={(value) => handleTransferConfirm(value)}
                similarEntitiesFetcher={getBenchmarkCustomizeTopsGameList}
                keywordsFetcher={getMobileBenchmarkGameList}
                entitiesFetcher={getMobileBenchmarkGameList}
                leftCellTitle={formatMessage({
                  id:
                    customGameList?.length > 0
                      ? 'dbi_compare_similar_games'
                      : 'dbi_benchmark_game_top',
                })}
                title={formatMessage({ id: 'dbi_benchmark_customize_set' })}
              />
              
            </div>
            {activeId === 'Figure' ? (
              <div className="dbi-benchmark-filter-item">
                <RegionSelect
                  options={regionConfig?.['figure'] || []}
                  value={region}
                  onChange={handleRegionChange}
                />
                  <FollowGame 
                    className='dbi-benchmark-follow-genre-mobile'
                    loading={customLoading}
                    entity_type='mobile'
                    gameList={followGameList}
                    genreList={GameSegmentOptions.map(item=> ({...item, text: formatMessage({id: item?.text})}))}
                    genre={activeSegment}
                    groupList={groupList}
                    getCollectionGroupList={getCollectionGroupList}
                  />
                {/* <div className="dbi-benchmark-follow-genre-mobile" onClick={()=> setFollowGameVisible(true)}>
                  { formatMessage({id: 'dbi_benchmark_follow_game_genre'}) }
                </div> */}
              </div>
            ) : (
              <Segment
                className="dbi-benchmark-stats-segment segment-light"
                options={statusSegmentList}
                value={statsActiveSegment}
                disabled={false}
                onChange={(value) =>
                  handleStatsSegmentChange(value as StatsSegmentType)
                }
              />
            )}
          </div>
        </div>
        {activeId === 'Figure' ? (
          <div>
            <RevenueTrends
              loading={figureLoading}
              segment={activeSegment}
              timePeriod={timePeriod}
              timeBasis={timeLine}
              levelValue={levelValue}
              trendsData={figureData?.trendsData}
              summaryData={figureData?.summaryData || []}
              revenueRegional={figureData?.revenueRegional}
              onTimeBasicChange={handleTimeBasicChange}
              onTimePeriodChange={handlePeriodChange}
            />
            <Retention
              loading={figureLoading}
              gameTotal={figureData?.gameTotal || 0}
              arpuRetention={figureData?.arpuRetention}
              retentionCurve={figureData?.retentionCurve}
            />
            <SystemRatios
              loading={figureLoading}
              ageBreakdown={figureData?.ageBreakdown}
              genderBreakdown={figureData?.genderBreakdown}
              ratioRegion={figureData?.ratioRegion}
              mobileDevice={figureData?.mobileDevice}
            />
          </div>
        ) : (
          <div
            ref={statsRef}
            className="dbi-benchmark-stats"
            style={{ marginTop: 20 }}
          >
            {statsActiveSegment !== 'basic_info' && (
              <RevenueSelector
                value={statsFilterValue}
                configGroup={StatsFilterGroupConfig?.[statsActiveSegment] || []}
                regionOptions={regionConfig?.[statsActiveSegment] || []}
                onConfirm={handleFilterConfirm}
                onReset={handleFilterRest}
              />
            )}
            <TableContent
              loading={tableLoading}
              onPagingChange={handlePagingChange}
              segment={statsActiveSegment}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalNum={Number(totalNum)}
              apiParams={apiParams}
              levelValue={levelValue}
              source={source}
              regionOptions={regionConfig?.[statsActiveSegment] || []}
              handleFetchTable={getTableList}
              filterValue={statsFilterValue}
              dataSource={dataSource}
            />
          </div>
        )}
      </Content.Body>
    </Content>
  );
};

export default MobileGameBenchMark;
